import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const ref = params.get("ref");
  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
        <XCircle size={64} className="text-amber-500 mx-auto mb-5" />
        <h1 className="text-2xl font-bold text-slate-800 mb-2">{t.payment.cancelled}</h1>
        {ref && <p className="text-slate-400 text-sm mb-6">{t.dashboard.ref}: <span className="font-mono font-semibold text-tigris">{ref}</span></p>}
        <div className="flex gap-3">
          <Link to="/" className="btn-primary flex-1 py-3 rounded-xl font-bold">{t.brand}</Link>
          {ref && <Link to={`/booking/${ref}`} className="btn-gold flex-1 py-3 rounded-xl font-bold">{t.dashboard.viewVoucher}</Link>}
        </div>
      </div>
    </div>
  );
}
